import './LandProductPanel.css'
import 'antd/dist/reset.css'
import React from 'react'
import { Divider, Row, Col, Button } from 'antd'
import {
  customers,
  varieties,
  getProductsOfCustomer,
  getProductsOfVariety,
} from '../../products/ProductProvider'

export default class LandProductPanel extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {}

  render() {
    return this.props.entry == 'customer' ? (
      <div>
        {customers.map((customer) => {
          return (
            <div>
              {' '}
              {this.getProductTitle(customer.name)}
              <Divider style={{ marginTop: 0, marginBottom: 0 }} />
              <div className="LandProductPanelRow">
                {this.getCustomerProducts(customer.cid)}
              </div>
            </div>
          )
        })}
      </div>
    ) : (
      <div>
        {varieties.map((variety) => {
          return (
            <div>
              {' '}
              {this.getProductTitle(variety.name, variety)}
              <Divider style={{ marginTop: 0, marginBottom: 0 }} />
              <div className="LandProductPanelRow">
                {this.getVarietyProducts(variety.vid)}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  getCustomerProducts = (cid) => {
    const products = getProductsOfCustomer(cid)
    var sp = 24 / products.length
    return (
      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32, xl: 40, xxl: 48 }, 40]}>
        {products.map((product) => (
          <Col span={sp}>{this.getProductCard(product)}</Col>
        ))}
      </Row>
    )
  }

  getVarietyProducts = (vid) => {
    const products = getProductsOfVariety(vid, 6)
    var sp = 24 / products.length
    return (
      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32, xl: 40, xxl: 48 }, 40]}>
        {products.map((product) => (
          <Col span={sp}>{this.getProductCard(product)}</Col>
        ))}
      </Row>
    )
  }

  getProductTitle = (titleName, variety) => {
    return (
      <div className="LandProductPanelTitleLayout">
        <div className="LandProductPanelTitle">{titleName}</div>
        {variety && variety.trimmed ? (
          <Button
            color="blue"
            variant="link"
            style={{
              fontSize: 12,
              fontWeight: 'bold',
              fontFamily: 'MyCustomizedFont',
            }}
            onClick={() => {
              this.props.handleClose()
              this.viewProductListOfVariety(variety.vid)
            }}
          >
            查看所有
          </Button>
        ) : null}
      </div>
    )
  }

  getProductCard = (product) => {
    return product ? (
      <div
        className="LandProductPanelCard"
        onClick={() => {
          this.props.handleClose()
          this.viewProductDetail(product.pid)
        }}
      >
        <img className="LandProductPanelCardImage" src={product.picture} />
        <div className="LandProductPanelCardName">{product.name}</div>
      </div>
    ) : (
      <div />
    )
  }

  viewProductDetail = (pid) => {
    this.props.history.push('/product?pid=' + pid)
  }

  viewProductList = () => {
    this.props.history.push('/product_list')
  }

  viewProductListOfVariety = (vid) => {
    this.props.history.push('/product_list?vid=' + vid)
  }
}
